// extracted by mini-css-extract-plugin
export default {"updatingBar":"VJ2UykQIJuEarQPp5V5s","active":"vFcA2GD5PLpbprSwCQtA","rv2SkeletonSlide":"ZS6fZRA38CC7EOlFv_7x","box":"pwQST6TX4TodPGUmeIOc","row":"sAl6p3WY3gxbbtl8PWAr"};